import type { CatalogItem } from '~/models/common'

export const gameMonetization: CatalogItem[] = [
  {
    label: 'F2P with Ads',
    value: 2,
  },
  {
    label: 'F2P with IAP',
    value: 3,
  },
  {
    label: 'Free',
    value: 1,
  },
  {
    label: 'Freemium',
    value: 4,
  },
  {
    label: 'Premium',
    value: 5,
  },
  {
    label: 'Premium with IAP',
    value: 6,
  },
  {
    label: 'Subscription',
    value: 7,
  },
]
